import { get, put } from '../axios/axiosGateway';

export const INDUSTRY_OPTIONS_MAP = {
  'smart-machine': 'Smart Machine',
  'smart-process': 'Smart Process',
  'smart-energy': 'Smart Energy',
  'smart-infrastructure': 'Smart Infrastructure',
  'smart-buildings': 'Smart Buildings',
  'smart-cities': 'Smart Cities',
  'smart-healthcare': 'Smart Healthcare',
  'asset-monitoring': 'Asset Monitoring',
};

export const INDUSTRY_OPTIONS = Object.entries(INDUSTRY_OPTIONS_MAP).map(
  ([value, label]) => ({ value, label }),
);

export const getUserCustomization = email => {
  return get(`/customization/assigned/${email}`);
};

export const putUserCustomization = (email, data, params) => {
  return put(`/customization/assign/${email}`, data, params);
};

export const getDefaultCustomization = () => {
  return get('/customization/default');
};

export const putSystemDefaultCustomization = (id, params) => {
  return put(`/customization/${id}/set-as-default`, null, params);
};
